import * as React from "react";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

export const ProductCustomizeStatus = ({pageShow, next}) => cs(
    ["status", (_, next) => UseState({next})],
    ({status}) => next({
        ...status.value == null || pageShow ? {
            active: false,
        } : {
            active: true,
            message: messages[status.value.type](status.value),
        },
        updating   : () => status.onChange({type: "updating"}),
        preparing  : () => status.onChange({type: "preparing"}),
        clear      : () => status.onChange(null),
        error      : () => status.onChange({type: "error"}),
        redirecting: (target) => status.onChange({type: "redirecting", target}),
    }),
);

const messages = {
    "updating"   : () => "Updating your Order...",
    "preparing"  : () => "Preparing your Order...",
    "redirecting": ({target}) => `Redirecting to ${target}...`,
    "error"      : () => `Something happened while we were preparing your order.
                            Please try again. If you continue to have this error please contact customer service.`,
};
